import React, { useState, useEffect, useMemo } from "react";
import { Space, Dropdown, Menu, Modal, Button, Input } from "antd";
import {
	CloseCircleOutlined,
	InfoCircleOutlined,
	PlusCircleOutlined,
	PlusOutlined,
	RightCircleOutlined,
} from "@ant-design/icons";
import {
	ActionButton,
	AntdButton,
	AntdTable,
	Buttons,
	ButtonsLeft,
	ConfirmButton,
	Container,
	ContainerTitle,
	FilterActions,
	FilterContainer,
	Filters,
	Inner,
	ModalContainer,
	RadioOptions,
	TableContainer,
	UploadFile,
} from "./styles";
import {
	openNotificationWithIcon,
	TYPE,
} from "../../../../../utils/notificationToast";
import LoadingHeader from "./components/LoadingHeader";
import { COLORS, Typo } from "../../../../layout/theme";
import DropShadow from "../../../../common/drop-shadow/DropShadow";
import SignInTemplate from "../../../../layout/sign-in-template/SignInTemplate";
import debounce from "lodash/debounce";
import { BsThreeDotsVertical } from "react-icons/bs";
import AntdSearch from "../../../../common/antd-search/AntdSearch";
import { useAuth } from "../../../../../contexts/authContext";
import PrePosTable from "./components/pre-pos-table/PrePosTable";
import {
	delete_user_discount,
	get_market_user_discounts,
	update_discounts_by_user_id,
} from "../../../../../api/endpoints/users";
import { numberWithDotAndCommas } from "../../../../../utils/numberWithDotAndComas";
import moment from "moment";
import {
	check_new_user_discounts,
	export_user_discounts,
} from "../../../../../api/endpoints/products";
import { CONSTANTS } from "../../../../../utils/constants";
import { calculatePercentage } from "../../../../../utils/calculatePrice";
import PrimaryButton from "../../../../common/antd-buttons/PrimaryButton";
import SecondaryButton from "../../../../common/antd-buttons/SecondaryButton";
import TerciaryButton from "../../../../common/antd-buttons/TerciaryButton";
import DefaultButton from "../../../../common/antd-buttons/DefaultButton";
import { convertLegacyProps } from "antd/lib/button/button";

const { confirm } = Modal;
let productIndex = null;

export default function UserDiscountList({
	clientId,
	client,
	userId,
	user,
	userType,
}) {
	const { userdata } = useAuth();
	const [loading, setLoading] = useState(false);
	const [headerInfo, setHeaderInfo] = useState(null);
	const [clientUserPos, setClientUserPos] = useState(null);
	const [state, setState] = useState("ACTIVE");
	const [key, setKey] = useState("null");
	const [page, setPage] = useState(1);
	const [hasChanges, setHasChanges] = useState(false);
	const [data, setData] = useState(null);
	const [searchPrePos, setSearchPrePos] = useState(null);
	const [searchModalShow, setSearchModalShow] = useState(false);
	const [toogleAdd, setToogleAdd] = useState(false);
	const [pageAdd, setPageAdd] = useState(1);
	const [errors, setErrors] = useState(null);
	const [importResponse, setImportResponse] = useState(null);
	const [productList, setProductList] = useState(null);

	useEffect(() => {
		if (productIndex) {
			setData(
				data?.filter((p, idx) => p.productId !== productIndex[0]?.productId),
			);
		}
	}, [productIndex]);

	const prePosColumns = [
		{
			title: () => <div style={{ color: COLORS.White }}>Nombre</div>,
			dataIndex: "productTitle",
			key: "productTitle",
			width: 300,
			render: (t, item) => (
				<ContainerTitle>
					<Typo
						type="primary"
						lineHeight={1}
						texto="medium"
						fontSize={t.length < 15 ? 18 : 16}
					>
						{t}
					</Typo>
					{"  "}
					<Typo type="muted" lineHeight={1} level={5}>
						{item?.productPresentation}
					</Typo>
				</ContainerTitle>
			),
		},
		{
			title: () => (
				<div style={{ color: COLORS.White }}>Descuento PSL marketplace</div>
			),
			dataIndex: "productDiscount",
			key: "productDiscount",
			width: 260,
			render: (t, item) => (
				<Container>
					<Typo type="success" lineHeight={1} level={5}>
						{`${numberWithDotAndCommas(
							(
								100 -
								(item.productOfferPrice * 100) / item.productPrice
							).toFixed(2),
						)}%`}
					</Typo>
					{item?.productMobileTriggerQty > 0 && (
						<Typo type="muted" lineHeight={1} level={8}>
							A partir de {item?.productTriggerQty} un.{" "}
							{item?.productTriggerDiscount} % de descuento
						</Typo>
					)}
				</Container>
			),
		},
		{
			title: () => <div style={{ color: COLORS.White }}>Agregar</div>,
			width: 100,
			key: "action",
			render: (_, record, index) => (
				<Space size="middle">
					<Button
						type="primary"
						ghost
						onClick={() => {
							handleAddToTemplate(index);
						}}
					>
						<RightCircleOutlined />
					</Button>
				</Space>
			),
		},
	];

	const columns = [
		{
			title: () => <div style={{ color: COLORS.White }}>Nombre</div>,
			dataIndex: "productTitle",
			key: "productTitle",
			render: (t, item) => (
				<ContainerTitle>
					<Typo
						type="primary"
						lineHeight={1}
						texto="medium"
						fontSize={t?.length < 15 ? 18 : 16}
					>
						{t}
					</Typo>
					{"  "}
					<Typo type="muted" lineHeight={1} level={5}>
						{item?.productPresentation}
					</Typo>
				</ContainerTitle>
			),
		},
		{
			title: () => (
				<div style={{ color: COLORS.White }}>Descuento PSL Usuario</div>
			),
			dataIndex: "userDiscount",
			width: 250,
			render: (value, record, index) => (
				<div
					style={{
						color: record.hasChanges ? COLORS.White : COLORS.Grey,
						display: "flex",
						alignItems: "center",
						gap: 20,
						fontWeight: "600",
					}}
				>
					<Input
						type="number"
						min={0}
						defaultValue={value}
						onChange={onInputChange(
							"userDiscount",
							page === 1 ? index : (page - 1) * 25 + index,
						)}
						addonAfter="%"
						style={{ width: "100px" }}
					/>
					<Typo type="secondary" level={8} translate="no">
						PVP -
						{calculatePercentage(
							record.productPrice,
							record.clientGeneralDiscount,
							record.userDiscount,
							0,
							0,
						)}
						%
					</Typo>
				</div>
			),
		},
		{
			title: () => (
				<div style={{ color: COLORS.White }}>Descuento por cantidad</div>
			),
			dataIndex: "userTriggerDiscount",
			width: 400,
			render: (value, record, index) => (
				<div
					style={{
						color: record.hasChanges ? COLORS.White : COLORS.Grey,
						display: "flex",
						alignItems: "center",
						gap: 20,
						fontWeight: "600",
					}}
				>
					<Input
						type="number"
						min={0}
						defaultValue={record.userTriggerQty}
						onChange={onInputChange(
							"userTriggerQty",
							page === 1 ? index : (page - 1) * 25 + index,
						)}
						addonAfter="un."
						style={{ width: "100px" }}
					/>
					{record?.userTriggerQty > 0 && (
						<Input
							type="number"
							min={0}
							defaultValue={record.userTriggerDiscount}
							onChange={onInputChange(
								"userTriggerDiscount",
								page === 1 ? index : (page - 1) * 25 + index,
							)}
							addonAfter="%"
							style={{ width: "100px" }}
						/>
					)}
					{record?.userTriggerDiscount > 0 && (
						<Typo type="terciary" lineHeight={1} level={8} translate="no">
							PVP -
							{calculatePercentage(
								parseFloat(record?.productPrice),
								parseFloat(record?.clientGeneralDiscount),
								parseFloat(record?.userDiscount),
								parseFloat(record?.userTriggerDiscount),
								0,
							)}
							%
						</Typo>
					)}
				</div>
			),
		},
		productIndex || importResponse
			? {
					title: "",
					key: "action",
					width: 30,
					render: (_, record, index) => (
						<Space size="middle">
							{record.hasChanges && (
								<CloseCircleOutlined onClick={() => handleDelete(index)} />
							)}
						</Space>
					),
				}
			: {
					title: "",
					key: "id",
					dataIndex: "id",
					width: 30,
					render: (f, r, i) => (
						<>
							<Dropdown overlay={menuActive} placement="bottomRight">
								<ActionButton key={`${f}`} onMouseOver={() => setKey(r)}>
									<BsThreeDotsVertical />
								</ActionButton>
							</Dropdown>
						</>
					),
				},
	];

	const menuActive = (
		<Menu
			items={[
				{
					key: "2",
					label: <Typo onClick={() => deleteRoute(key?.id)}>Eliminar</Typo>,
				},
			]}
		/>
	);

	const onInputChange = (key, index) => (e) => {
		const newData = [...clientUserPos];

		if (key === "userDiscount") {
			newData[index]["userDiscount"] = Number(e.target.value);
		}
		if (key === "userTriggerDiscount") {
			newData[index]["userTriggerDiscount"] = Number(e.target.value);
		}
		if (key === "userTriggerQty") {
			if (Number(e.target.value) === 0) {
				newData[index]["userTriggerDiscount"] = 0;
			}
			newData[index]["userTriggerQty"] = Number(e.target.value);
		}

		newData[index]["hasChanges"] = true;
		setClientUserPos(newData);
		setHasChanges(true);
	};

	const fetch_user_discounts = async (search, state, userId, clientId) => {
		setLoading(true);
		try {
			const res = await get_market_user_discounts(
				search,
				userId,
				clientId,
				state,
			);
			setClientUserPos(
				res?.userProducts
					?.map((r) => ({
						...r,
						key: r.id,
						hasChanges: false,
					}))
					?.sort((a, b) => {
						const titleA = a.productTitle.toLowerCase();
						const titleB = b.productTitle.toLowerCase();
						if (titleA < titleB) {
							return -1;
						}
						if (titleA > titleB) {
							return 1;
						}

						return 0;
					}),
			);
			setProductList(
				res?.clientProducts?.map((r) => ({
					...r,
					key: r.productId,
					hasChanges: true,
				})),
			);
			setHeaderInfo(res?.headers);
		} catch (error) {
			console.log(error);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		fetch_user_discounts("", state, userId, clientId);
		setLoading(false);
	}, [state, userId]);

	useEffect(() => {
		return () => {
			debouncedEventHandler.cancel();
		};
	}, []);

	const eventHandler = (e) => {
		fetch_user_discounts(e.target.value, state, userId, clientId);
	};

	const debouncedEventHandler = useMemo(
		() => debounce(eventHandler, 600),
		[userId],
	);

	const deleteRoute = (key) => {
		confirm({
			title: "¿Seguro que quiere eliminar este descuento?",
			icon: <CloseCircleOutlined style={{ color: "red" }} />,
			content: "La relación se quitará de inmediato",
			okText: "Sí",
			okType: "default",
			cancelText: "No",
			onOk: () => {
				handleAction(key);
			},
		});
	};

	const handleAction = async (key) => {
		try {
			await delete_user_discount(key);
			fetch_user_discounts("", state, userId, clientId);
		} catch (err) {
			openNotificationWithIcon(
				TYPE.ERROR,
				"El descuento no se puede borrar",
				"El descuento no se puede borrar",
			);
		}
	};

	const fetch_export_user_discounts = async () => {
		setLoading(true);
		try {
			const res = await export_user_discounts(clientId);
			const href = URL.createObjectURL(res);
			const link = document.createElement("a");
			link.href = href;
			const fileName = moment().format("DD-MM-YYYY") + ".xlsx";
			link.setAttribute("download", fileName);
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
			URL.revokeObjectURL(href);
		} catch (error) {
		} finally {
			setLoading(false);
		}
	};

	const handleUpload = async (e) => {
		setLoading(true);
		try {
			const formData = new FormData();
			formData.append("data", clientId ?? userdata.clientId);
			formData.append("file", e.fileList[e.fileList.length - 1].originFileObj);
			const res = await check_new_user_discounts(formData);
			setClientUserPos(
				res.productsToChange.map((i) => ({
					...i,
					productId: i.id,
					productTitle: i.title,
					userDiscount: i.discount,
					userTriggerDiscount: i.triggerDiscount,
					userTriggerQty: i.triggerQty,
				})),
			);
			const thereIsChanges = res.productsToChange.length > 0;
			setHasChanges(thereIsChanges);
		} catch (err) {
			openNotificationWithIcon(
				TYPE.ERROR,
				"Los precios no pudieron actualizarse",
				"Verifique su archivo de excel, si sigue con problemas contacte con soporte a soporte@checkpos.com",
			);
		} finally {
			setLoading(false);
		}
	};

	const handleSubmit = () => {
		confirm({
			title: "¿Seguro que quiere publicar estos descuentos?",
			icon: <InfoCircleOutlined style={{ color: "blue" }} />,
			content: "Los cambios se aplicaran de inmediato",
			okText: "Sí",
			okType: "default",
			cancelText: "No",
			onOk: () => {
				confirmChanges();
			},
		});
	};

	const confirmChanges = async () => {
		try {
			const res = await update_discounts_by_user_id({
				userDiscounts: clientUserPos.map((d) => ({ ...d, userType: userType })),
				userId: userId,
				relationOrigin: CONSTANTS.PRODUCTS_ORIGIN_WEB_SELLER,
			});
			openNotificationWithIcon(
				TYPE.SUCCESS,
				res,
				"Los descuentos se actualizaron correctamente",
			);
			productIndex = null;
			setHasChanges(false);
			setImportResponse(null);
			fetch_user_discounts("", state, userId, clientId);
		} catch (err) {
			console.log(err);
			openNotificationWithIcon(
				TYPE.ERROR,
				"Los descuentos no se pudieron actualizar correctamente, contacte con soporte a soporte@checkpos.com",
				"Los descuentos se se pudieron actualizar correctamente, contacte con soporte a soporte@checkpos.com",
			);
		}
	};

	const fetch_client_products = async (search) => {
		setLoading(true);
		try {
			setData(
				productList
					?.filter((o) => {
						return Object.keys(o).some((k) => {
							return (
								typeof o[k] === "string" &&
								k === "productTitle" &&
								o[k].toLowerCase().includes(search.toLowerCase())
							);
						});
					})
					?.map((p) => ({ ...p, key: p.productId }))
					?.sort((a, b) => {
						const titleA = a.productTitle.toLowerCase();
						const titleB = b.productTitle.toLowerCase();
						if (titleA < titleB) {
							return -1;
						}
						if (titleA > titleB) {
							return 1;
						}

						return 0;
					}),
			);
		} catch (error) {
			console.log(error);
		} finally {
			setLoading(false);
			setSearchModalShow(true);
		}
	};

	//////******************************************************** */

	const handleAddToTemplate = async (e, q) => {
		const _template = data?.filter((p, idx) => idx === e);
		productIndex = _template;
		const auxTemplate = clientUserPos.concat(_template);

		let uniqueArray = auxTemplate.filter((value, index) => {
			const _value = JSON.stringify(value);
			return (
				index ===
				auxTemplate.findIndex((obj) => {
					return JSON.stringify(obj) === _value;
				})
			);
		});

		uniqueArray = uniqueArray.filter(
			(value, index, self) =>
				index === self.findIndex((t) => t.productId === value.productId),
		);

		setClientUserPos(uniqueArray);
	};

	//////******************************************************** */

	const handleDelete = (index) => {
		const _template = clientUserPos.filter((p, idx) => idx !== index);
		setClientUserPos(_template);
	};

	//////******************************************************** */

	const eventHandlerAdd = (e) => {
		setSearchPrePos(e.target.value);
		fetch_client_products(e.target.value);
	};

	const debouncedEventHandlerAdd = useMemo(
		() => debounce(eventHandlerAdd, 600),
		[productList],
	);

	const handleModalOk = () => {
		setSearchPrePos(null);
		setSearchModalShow(false);
	};

	const handleModalCancel = () => {
		setSearchPrePos(null);
		setSearchModalShow(false);
	};

	const handleCancel = () => {
		productIndex = null;
		setHasChanges(false);
		setImportResponse(null);
		setClientUserPos(null);
		fetch_user_discounts("", state, userId, clientId);
	};

	return (
		<Inner>
			<Filters>
				{!headerInfo && !productList ? (
					<LoadingHeader />
				) : (
					<FilterContainer>
						<AntdSearch
							width={300}
							allowClear
							placeholder="Buscar asignados"
							onChange={debouncedEventHandler}
							style={{ borderRadius: 15 }}
						/>
						<div>
							{!toogleAdd && (
								<PrimaryButton
									onClick={() => setToogleAdd((prev) => !prev)}
									icon={<PlusCircleOutlined />}
									disabled={!!importResponse || !!productIndex}
									style={{ width: 200 }}
								>
									Agregar Producto
								</PrimaryButton>
							)}
							{toogleAdd && (
								<div style={{ display: "flex", gap: 10 }}>
									<AntdSearch
										allowClear
										placeholder="Buscar producto en listado"
										width={300}
										onChange={(e) => setSearchPrePos(e.target.value)}
										value={searchPrePos}
										onPressEnter={(e) => debouncedEventHandlerAdd(e)}
										disabled={loading}
										style={{ borderRadius: 15 }}
									/>
									<CloseCircleOutlined
										size="small"
										style={{ color: COLORS.Danger }}
										onClick={() => setToogleAdd((prev) => !prev)}
									/>
								</div>
							)}
						</div>
						<FilterActions>
							<DefaultButton
								loading={loading}
								onClick={fetch_export_user_discounts}
								style={{ width: 250, border: `1px solid ${COLORS.MediumGrey}` }}
							>
								Exportar listado completo
							</DefaultButton>
							<UploadFile
								multiple={false}
								showUploadList={false}
								beforeUpload={() => false}
								action={null}
								onChange={handleUpload}
								loading={loading}
							>
								Importar descuentos
							</UploadFile>
						</FilterActions>
					</FilterContainer>
				)}
			</Filters>
			{clientId && (hasChanges || productIndex) && (
				<ConfirmButton clientId={clientId}>
					<TerciaryButton onClick={handleSubmit} success>
						Confirmar cambios
					</TerciaryButton>{" "}
					<DefaultButton
						onClick={handleCancel}
						style={{ border: `1px solid ${COLORS.MediumGrey}` }}
					>
						Cancelar cambios
					</DefaultButton>
				</ConfirmButton>
			)}
			<TableContainer containerBackground={COLORS.White}>
				<AntdTable
					dataSource={clientUserPos}
					columns={columns}
					loading={loading}
					pagination={{
						pageSize: 300,
						showSizeChanger: false,
						onChange: (page) => setPage(page),
					}}
					// scroll={{
					// 	y: 450,
					// }}
					rowClassName={(record) => (record.hasChanges ? "hasChanges" : null)}
				/>
			</TableContainer>
			<Modal
				open={searchModalShow}
				onOk={handleModalOk}
				onCancel={handleModalCancel}
				width={900}
				centered={true}
				footer={null}
				destroyOnClose={true}
			>
				<ModalContainer>
					<PrePosTable
						data={data}
						columns={prePosColumns}
						loading={loading}
						pagination={{
							pageSize: 100,
							showSizeChanger: false,
							onChange: (page) => setPageAdd(page),
						}}
						scrollData={{ y: 350 }}
					/>
				</ModalContainer>
			</Modal>
		</Inner>
	);
}
